import { createContext,useContext } from "react";
import {ContextSession} from '../../services/ContextSession';
import DashDefault from "../../Components/Dash_default";

export default function RnpDash(){
    const { sessionData } = useContext(ContextSession);
  const { nombre,apellido, username } = sessionData;
    return (
        <>
            <DashDefault nombre={nombre} apellido={apellido} modulo={"Consultas Registro Nacional Personas"} />
        </>
    );
}